import React, { Component } from 'react'
import { Form, Field } from 'redux-form'

import { Container } from 'components/Layout'
import Button from 'components/Button'
import SelectPretty from 'components/Input/SelectPretty'
import { Textarea } from 'components/Input/Textarea'
import { vChecked, vRequired } from 'components/Input/Input.validations'
import CheckboxRow from 'components/Input/CheckboxRow'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

const symptomOptionsNumbers = [
  'Calls not connecting',
  'Calls Drop Out',
  'One Way Speech',
  'Poor Call Quality',
  'Wrong Number Terminating',
  'Other',
].map(item => ({ value: item, name: item }))

const symptomOptionsPhoneLine = [
  'Calls not connecting',
  'Calls Drop Out',
  'No Dial Tone',
  'One Way Speech',
  'Poor Call Quality',
  'No Network',
].map(item => ({ value: item, name: item }))

const symptomOptionsPhoneSystem = [
  'Call Feature Issue',
  'Calls not connecting',
  'Calls Drop Out',
  'One Way Speech',
  'Poor Call Quality',
  'Wrong Number Terminating',
  'No Dial Tone',
  'Other',
].map(item => ({ value: item, name: item }))

const symptomOptionsInternet = [
  'Browsing Issues',
  'Drop Outs',
  'Latency',
  'No Connectivity',
  'Speed Issue',
].map(item => ({ value: item, name: item }))

const impactOptions = ['Partial Loss', 'Total Loss'].map(item => ({ value: item, name: item }))

export default class CasesCreateTroubleTicket extends Component {
  onSubmit = formData => {
    const { createTroubleTicket, modalConfirm } = this.props
    return createTroubleTicket(formData).then(modalConfirm)
  }
  render() {
    const { modalCancel, submitting, handleSubmit, type = 'number', invalid } = this.props

    let symptomOptions
    if (type === 'phoneSystem') {
      symptomOptions = symptomOptionsPhoneSystem
    } else if (type === 'phoneLine') {
      symptomOptions = symptomOptionsPhoneLine
    } else if (type === 'internet') {
      symptomOptions = symptomOptionsInternet
    } else {
      symptomOptions = symptomOptionsNumbers
    }

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Submit a Trouble Ticket:</div>
          <br />
          {type === 'phoneSystem' && (
            <div style={{ marginBottom: '30px' }}>
              <div className={sText.descrip3} style={{ marginBottom: '10px' }}>
                Please complete these steps, if you are still having issues, submit a ticket here.
              </div>
              <div className={sText.descrip3}>
                - Restart your router, switch, phone and computer.
              </div>
              <div className={sText.descrip3}>
                - If you have handsets; also press and HOLD the OK button for 8-10 secs until a
                warning shows up to factory reset, press the OK button.
              </div>
            </div>
          )}
          <Form onSubmit={handleSubmit(this.onSubmit)}>
            <Field
              label="Symptoms"
              name="symptom"
              component={SelectPretty}
              options={symptomOptions}
              validate={[vRequired]}
            />
            <Field
              label="Impact"
              name="impact"
              component={SelectPretty}
              options={impactOptions}
              validate={[vRequired]}
            />
            <Field
              label="Description"
              name="description"
              display="standard"
              component={Textarea}
              validate={[vRequired]}
            />
            <Field name="repeatFault" component={CheckboxRow} style={{ margin: '30px 0' }}>
              This has occured more than once.
            </Field>
            {['internet', 'phoneLine'].includes(type) ? (
              <div>
                <div className={sText.descrip4}>
                  A service restoration charge will be applied in the event that our contractors
                  attend an end user's premise or somewhere else for a fault condition, or the fault
                  is restored remotely and the cause of the fault is found to not be part of the
                  Think Pickle network but in your end user's private equipment or internal cabling
                  unless the equipment is managed by Think Pickle.
                  <br />
                  <br />
                  Please note that private equipment includes but is not necessarily limited to
                  items such as end user modems and routers, auto dialers, fax machines, and other
                  non-Think Pickle equipment.
                </div>
                <Field
                  name="disclaimer"
                  component={CheckboxRow}
                  style={{ margin: '30px 0' }}
                  validate={[vChecked]}
                >
                  I Agree to the above terms.
                </Field>
              </div>
            ) : null}
            <div
              className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
              style={{ marginTop: '40px' }}
            >
              <Button color="tertiary" type="submit" loading={submitting} disabled={invalid}>
                Submit
              </Button>
              <br />
              <br />
              <Button plain onClick={modalCancel}>
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesCreateTroubleTicket/CasesCreateTroubleTicket.jsx